import { useCallback } from "react"
import { useDispatch } from "react-redux"
import useSearchFilter from "hooks/useSearchFilter"
import { getCalendarBookings } from "store/calendar"
import { useCalendarDateRange } from "./useCalendarDateRange"

export function useRefreshCalendarBookings() {
  const dispatch = useDispatch()
  const [params] = useSearchFilter({ accessAttributes: ["range", "date", "tab"] })
  const dates = useCalendarDateRange(params)

  return useCallback(() => {
    if (!dates?.start || !dates?.end) return

    const apiParams = new URLSearchParams()

    if (params.range === "date") {
      apiParams.set("date", dates.start)
    } else {
      apiParams.set("start_date", dates.start)
      apiParams.set("end_date", dates.end)
    }

    if (params.tab === "my-bookings") {
      apiParams.set("view_type", "my_bookings")
    }

    dispatch(getCalendarBookings(apiParams))
  }, [dates?.start, dates?.end, params.range, params.tab, dispatch])
}
